
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Swiftdezireonrentinpune() {



    const cardData =
    {
        keyword: ' Swift Dzire On Rent in Pune ',
        heading: 'Skyline Cabs: Swift Dzire On Rent in Pune',
        headingDescription: 'Skyline Cabs offers reliable and budget-friendly Swift Dzire on Rent in Pune for all your local and outstation travel needs. Ideal for solo travelers, couples, or small families, our well-maintained Swift Dzire cars provide excellent comfort, fuel efficiency, and a smooth ride. With professional drivers, flexible rental options, transparent pricing, and 24/7 customer support, Skyline Cabs ensures a hassle-free and pleasant travel experience. Book your Swift Dzire in Pune today and enjoy a comfortable ride at affordable rates.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    
    
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Swift Dzire on Rent in Pune",
      "description": "Skyline Cabs offers Swift Dzire on rent in Pune for both local and outstation trips. Known for its fuel efficiency, comfortable seating, and affordable pricing, it is the perfect choice for individuals, families, and business travelers."
    },
    {
      "name": "Dzire on Rent for Outstation",
      "description": "Rent a Swift Dzire for outstation travel from Pune with Skyline Cabs. Whether you're traveling to nearby cities or planning a long road trip, the Dzire offers great mileage, smooth driving experience, and ample comfort for up to 4 passengers."
    },
    {
      "name": "Per km Rate for Swift Dzire Cab",
      "description": "The per-kilometer rate for Swift Dzire rental in Pune starts at ₹10-₹12/km. Rates vary based on distance, travel time, and vehicle availability. Get in touch with Skyline Cabs for transparent and competitive pricing."
    },
    {
      "name": "Dzire Per km Rate for Cab Booking",
      "description": "Book a Swift Dzire for your travels in Pune and enjoy affordable rates starting at ₹10 per km. Skyline Cabs offers the most competitive pricing with no hidden charges for local and outstation journeys."
    },
    {
      "name": "Swift Dzire Per km Rate in Pune",
      "description": "Skyline Cabs offers Swift Dzire rentals at ₹10-₹12 per km for local travel within Pune. Enjoy smooth, reliable, and budget-friendly services with our well-maintained Swift Dzire fleet."
    },
    {
      "name": "Swift Dzire Rent Per km Rate for Outstation",
      "description": "For outstation trips, Skyline Cabs provides Swift Dzire rental at ₹10-₹15 per km. We offer flexible packages for short trips or long road journeys to popular destinations across Maharashtra and beyond."
    },
    {
      "name": "Swift Dzire Rent Per Day",
      "description": "Skyline Cabs offers Swift Dzire rentals by the day starting at ₹1,200 per day. This includes a driver, fuel charges, and door-to-door service for a day trip within Pune or to nearby areas."
    },
    {
      "name": "Swift Dzire Taxi Rate Per km",
      "description": "Skyline Cabs offers competitive per km rates for Swift Dzire taxi services. Prices start at ₹10/km for local travel within Pune and ₹12/km for outstation travel, ensuring that you get great value for money."
    },
    {
      "name": "Pune to Mahabaleshwar Swift Dzire Tour",
      "description": "Book a Swift Dzire for your Pune to Mahabaleshwar tour with Skyline Cabs. Enjoy the scenic drive to this hill station with a comfortable and well-maintained Swift Dzire, perfect for a family or small group."
    },
    {
      "name": "Pune to Shirdi Swift Dzire Cab",
      "description": "Skyline Cabs provides Swift Dzire cabs for your Pune to Shirdi pilgrimage trip. Comfortable, air-conditioned rides ensure a relaxing journey as you visit the famous Sai Baba temple."
    },
    {
      "name": "Pune to Lonavala Swift Dzire Cab",
      "description": "Travel to Lonavala in style with Skyline Cabs’ Swift Dzire. Enjoy a relaxing ride through the scenic hills with this fuel-efficient and comfortable car, ideal for family and group trips."
    },
    {
      "name": "Pune to Ashtavinayak Swift Dzire Cab",
      "description": "Skyline Cabs offers Swift Dzire for your Pune to Ashtavinayak pilgrimage trip. Visit the eight sacred Ganesh temples in comfort and style, with a knowledgeable and courteous driver to guide you."
    },
    {
      "name": "Pune to Mumbai Airport Swift Dzire Cab",
      "description": "Book a Swift Dzire for your airport transfer from Pune to Mumbai with Skyline Cabs. Enjoy a smooth, comfortable ride with punctual service to ensure you catch your flight on time."
    },
    {
      "name": "Pune to Goa Swift Dzire Hire",
      "description": "Skyline Cabs offers Swift Dzire hire for your Pune to Goa trip. Enjoy the journey with a reliable driver, comfortable seats, and smooth roads, making your Goa vacation hassle-free."
    },
    {
      "name": "Pune to Bhimashankar Swift Dzire Taxi",
      "description": "Rent a Swift Dzire from Skyline Cabs for your Pune to Bhimashankar trip. The Dzire is an ideal vehicle for visiting the Bhimashankar Temple, ensuring comfort and reliability on this pilgrimage."
    },
    {
      "name": "Swift Dzire Taxi for Outstation",
      "description": "Skyline Cabs offers Swift Dzire taxis for outstation trips, providing comfort and reliability for long-distance travel. Book now for a stress-free journey to various destinations across Maharashtra and beyond."
    },
    {
      "name": "Swift Dzire Cab for Corporate Employees",
      "description": "Skyline Cabs offers Swift Dzire rental services for corporate employees, perfect for business travel, corporate events, and meetings. Our reliable fleet ensures that your team travels in comfort and punctuality."
    },
    {
      "name": "Cab Services for Corporate Events",
      "description": "Skyline Cabs provides Swift Dzire rentals for corporate events, offering comfortable and professional travel for your team. Whether it's for conferences, meetings, or client visits, we ensure top-notch service."
    }
  ],
  "tableData": [
    ["Swift Dzire on Rent in Pune", "Dzire on Rent for Outstation"],
    ["Per km Rate for Swift Dzire Cab", "Dzire Per km Rate for Cab Booking"],
    ["Swift Dzire Per km Rate in Pune", "Swift Dzire Rent Per km Rate for Outstation"],
    ["Swift Dzire Rent Per Day", "Swift Dzire Taxi Rate Per km"],
    ["Pune to Mahabaleshwar Swift Dzire Tour", "Pune to Shirdi Swift Dzire Cab"],
    ["Pune to Lonavala Swift Dzire Cab", "Pune to Ashtavinayak Swift Dzire Cab"],
    ["Pune to Mumbai Airport Swift Dzire Cab", "Pune to Goa Swift Dzire Hire"],
    ["Pune to Bhimashankar Swift Dzire Taxi", "Swift Dzire Taxi for Outstation"],
    ["Swift Dzire Cab for Corporate Employees", "Cab Services for Corporate Events"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Swift Dzire Rental Service in Pune",
        "WhyChoosedescription": "We offer reliable and punctual Swift Dzire rental services in Pune, perfect for both business trips and leisure travels. Enjoy a smooth ride every time."
    },
    {
        "WhyChooseheading": "Comfortable and Economical Ride",
        "WhyChoosedescription": "The Swift Dzire is known for its fuel efficiency, comfortable ride, and spacious interiors. It’s an affordable yet premium option for your travel needs in Pune."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Our Swift Dzire cars are regularly serviced and sanitized before every trip, ensuring a clean, comfortable, and safe journey for all passengers."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced, knowledgeable of the best routes in Pune, and focused on your safety and comfort throughout the ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive, transparent pricing for Swift Dzire rentals in Pune. Enjoy a budget-friendly ride without any hidden charges."
    },
    {
        "WhyChooseheading": "Flexible Rental Options",
        "WhyChoosedescription": "Book a Swift Dzire for hourly, daily, or outstation trips. Our flexible rental packages allow you to customize your trip according to your needs."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Book your Swift Dzire online or over the phone anytime, with 24/7 customer support. We ensure a seamless booking experience and are always ready to assist you."
    },
    {
        "WhyChooseheading": "Ideal for All Occasions",
        "WhyChoosedescription": "Whether it’s a corporate meeting, a family trip, or a weekend getaway, the Swift Dzire offers a comfortable and efficient ride for any occasion."
    }
]























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Swift Dzire in Pune with Skyline Cabs?',
            answer:
                'Renting a Swift Dzire in Pune with Skyline Cabs is easy. Simply visit our website, use the mobile app, or contact our customer support team. Choose Swift Dzire as your preferred vehicle, provide your travel details, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What makes the Swift Dzire a good option for rental in Pune?',
            answer:
                'The Swift Dzire is known for its fuel efficiency, comfort, and affordability. It is perfect for both short and long trips, making it an ideal choice for business and leisure travel in and around Pune.',
        },
        {
            id: 3,
            question: 'Is the Swift Dzire available for local and outstation rentals in Pune?',
            answer:
                'Yes, you can rent a Swift Dzire for both local rides within Pune and outstation trips to destinations like Mumbai, Lonavala, Mahabaleshwar, and more.',
        },
        {
            id: 4,
            question: 'Are the rental rates for Swift Dzire in Pune fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed and transparent pricing. Your fare includes all charges such as driver fees, tolls, and taxes, ensuring no hidden costs.',
        },
        {
            id: 5,
            question: 'Can I book a one-way trip with Swift Dzire from Pune?',
            answer:
                'Yes, you can book a one-way trip with Swift Dzire from Pune to other cities. Just specify your destination when making the booking.',
        },
        {
            id: 6,
            question: 'Is the Swift Dzire suitable for corporate travel?',
            answer:
                'Yes, the Swift Dzire is an excellent choice for corporate travel in Pune. It provides a comfortable and cost-effective solution for business meetings, airport transfers, and short trips.',
        },
        {
            id: 7,
            question: 'Are the Swift Dzire vehicles clean and well-maintained?',
            answer:
                'Yes, all our Swift Dzire vehicles are regularly cleaned, sanitized, and maintained for safety and comfort. We prioritize hygiene and vehicle upkeep to ensure a smooth journey.',
        },
        {
            id: 8,
            question: 'What payment options are available for Swift Dzire rental in Pune?',
            answer:
                'We accept payments through UPI, credit/debit cards, net banking, or in cash at the end of your trip. All payment methods are secure and convenient.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Swift Dzire booking?',
            answer:
                'Yes, you can easily modify or cancel your booking through our app, website, or by contacting our customer support team. We offer flexible terms to accommodate your plans.',
        },
        {
            id: 10,
            question: 'Why should I rent a Swift Dzire with Skyline Cabs in Pune?',
            answer:
                'Skyline Cabs offers affordable, reliable, and efficient rental services. Renting a Swift Dzire with us ensures you get a comfortable ride with professional drivers, on-time service, and no hidden charges.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Rented a Swift Dzire for a short trip from Pune to Lonavala. The car was clean, comfortable, and the driver was very professional. Excellent service from Skyline Cabs!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a pleasant experience with the Swift Dzire rental. It was the perfect car for my solo trip in Pune. Would definitely recommend Skyline Cabs for their punctual service!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Pune",
  "image": "https://skylinecabs.com/assets/images/swift-dzire-on-rent-pune.jpg",
  "description": "Book Swift Dzire on rent in Pune with Skyline Cabs for affordable, clean, and comfortable travel. Ideal for airport transfers, daily city rides, and outstation trips — available 24/7 with expert drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8453"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1400",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/swift-dzire-on-rent-in-pune"
  }
};


      
    
      



    return (
        <div>
<Helmet>
  <title>Swift Dzire on Rent in Pune | Affordable Sedan Cab 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Swift Dzire on rent in Pune with Skyline Cabs for affordable, clean, and comfortable travel. Ideal for airport transfers, daily city rides, and outstation trips — available 24/7 with expert drivers." 
  />
  <meta 
    name="keywords" 
    content="Swift Dzire on Rent in Pune, Rent Dzire Pune, Swift Dzire Cab Pune, Sedan Cab Booking Pune, Dzire Airport Cab Pune, Dzire Outstation Cab Pune, Dzire Taxi in Pune, Dzire with Driver Pune, Skyline Cabs Dzire Rental" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/74.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Swiftdezireonrentinpune;